// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordPage":"ForgotPasswordPage_forgotPasswordPage__1Z81U","branding":"ForgotPasswordPage_branding__y4J2B"};